import React, { useState, useEffect } from 'react';
import { dictationColumns } from './voiceDictation.constant';
import { Icon } from '@ohif/ui';
import ApiServices from '../../shared/ApiServices/ApiServices';
import { toast } from 'react-toastify';
import ModernPageHeader from '../WorkListTable/components/ModernPageHeader';
import { Mic } from 'lucide-react';

const VoiceDictation = () => {
    const [dictations, setDictations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDictations();
    }, []);

    const fetchDictations = async () => {
        setLoading(true);
        try {
            const response = await ApiServices.getVoiceDictation();
            setDictations(response.data);
        } catch (error) {
            console.error('Error fetching dictations:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async dictationId => {
        try {
            await ApiServices.deleteVoiceDictation({ VoiceDictationID: dictationId });

            const updatedDictations = dictations.filter(
                dictation => dictation.VoiceDictationID !== dictationId
            );
            setDictations(updatedDictations);
        } catch (error) {
            toast.error('Error deleting dictation:', error.message);
        }
    };

    return (
        <>
            <ModernPageHeader
                title="Dictation History"
                subtitle="Review and manage your voice dictation recordings"
                icon={<Mic className="w-[15px] h-[15px]" />}
            />

            {loading ? (
                <div className="flex-center h-full w-full">
                    <div className="h-20 w-20 animate-spin rounded-full border-8 border-gray-300 border-t-blue-600" />
                </div>
            ) : (
                <div
                    className="ohif-scrollbar ohif-scrollbar-stable-gutter overflow-x-auto p-2"
                    style={{ overflow: 'hidden' }}
                >
                    <table className="min-w-full divide-y" style={{ borderColor: 'var(--border-subtle)' }}>
                        <thead className="sticky top-[-8px]" style={{ background: 'var(--bg-surface)' }}>
                            <tr>
                                {dictationColumns.map((header, index) => (
                                    <th
                                        key={index}
                                        className="border-b px-6 py-3 text-center text-sm uppercase tracking-wider"
                                    >
                                        {header.title}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="divide-y" style={{ borderColor: 'var(--border-subtle)' }}>
                            {dictations.length > 0 ? (
                                dictations.map((dictation, index) => (
                                    <tr
                                        key={dictation.VoiceDictationID}
                                        className="cursor-pointer transition-colors"
                                        style={{ fontSize: '14px', background: index % 2 === 0 ? 'var(--bg-card)' : 'var(--bg-surface)' }}
                                    >
                                        {dictationColumns.map((item, subIndex) => (
                                            <td
                                                key={subIndex}
                                                className={`whitespace-nowrap border-b py-2 text-center text-sm md:text-base ${item.isAction ? 'flex items-center justify-center' : ''
                                                    }`}
                                                data-label={item.title}
                                            >
                                                {item.isAction ? (
                                                    <Icon
                                                        name="delete-Icon"
                                                        className="h-5 w-5 cursor-pointer text-red-500"
                                                        onClick={() => handleDelete(dictation.VoiceDictationID)}
                                                    />
                                                ) : item.formatter ? (
                                                    item.formatter(dictation[item.key], index)
                                                ) : (
                                                    dictation[item.key]
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={dictationColumns.length}
                                        className="px-6 py-4 text-center text-sm font-semibold"
                                        style={{ color: 'var(--text-muted)' }}
                                    >
                                        No Dictations Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

export default VoiceDictation;
